import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: '/form/app-forms',
    method: 'get',
    params: query
  })
}

export function fetchFormInsurance(id) {
  return request({
    url: '/form/insurance/' + id,
    method: 'get'
  })
}
export function getUpdateTime(id) {
  return request({
    url: '/form/get-time/' + id,
    method: 'get'
  })
}
export function tempSaveAppForm(data) {
  return request({
    url: '/form/temp-save',
    method: 'post',
    data
  })
}

export function createAppForm(data) {
  return request({
    url: '/form/app-forms',
    method: 'post',
    data
  })
}

export function fetchAppForm(id) {
  return request({
    url: '/form/app-form/' + id,
    method: 'get'
  })
}

export function fetchAppFormByID(id) {
  return request({
    url: '/form/app-form/' + id,
    method: 'get'
  })
}

export function exportAppForm(id, file_type,write_date) {
  let params = {type: file_type,'write_date':write_date}
  return request({
    url: '/form/app-form/' + id,
    method: 'post',
    params: params,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export function deleteAppForm(id) {
  return request({
    url: '/form/app-form/' + id,
    method: 'delete'
  })
}

export function copyAppForm(id) {
  return request({
    url: '/form/app-form/copy/' + id,
    method: 'get'
  })
}

export function getExceptContent(id) {
  return request({
    url: '/form/content/' + id,
    method: 'get'
  })
}

export function fetchAppFormModifyApplicationList(query) {
  return request({
    url: '/form/app-form-modify-applications',
    method: 'get',
    params: query
  })
}

export function createAppFormModifyApplication(data) {
  return request({
    url: '/form/app-form-modify-applications',
    method: 'post',
    data
  })
}

export function checkAppFormModifyApplication(id, data) {
  return request({
      url: '/form/app-form-modify-application/check/' + id,
      method: 'post',
      data
  })
}

export function fetchAppFormModifyApplicationDetail(id) {
  return request({
      url: '/form/app-form-modify-application/' + id,
      method: 'get',
  })
}

export function deleteAppFormModifyApplication(id) {
  return request({
    url: '/form/app-form-modify-application/' + id,
    method: 'delete'
  })
}

export function fetchLastAppForm(query) {
  return request({
    url: '/form/last-app-form',
    method: 'get',
    params: query
  })
}

export function getRelateContact(query) {
  return request({
    url: '/form/get-contact',
    method: 'get',
    params: query
  })
}

export function getShipForm(query) {
  return request({
    url: '/form/ship-form',
    method: 'get',
    params: query
  })
}


export function fetchElectronic(query) {
  return request({
    url: '/form/electronic',
    method: 'get',
    params: query
  })
}


export function toForm(data) {
  return request({
    url: '/form/to-form',
    method: 'post',
    data
  })
}
